const clientPublicKey = `-----BEGIN PUBLIC KEY-----
MIGeMA0GCSqGSIb3DQEBAQUAA4GMADCBiAKBgHZhY4oE2WcDSDJpPApP8uuQTODN
jJBCrnSo7YF0PyfbnNg16TBX3ZqnLV1LREU2aWmUpqvYMEypvTzfoBNFhBv2u/Rx
IXLVSptPNybA+ux/p7Ce0/nbzzvyL0phNAfBugUJppLbVgiDIk2HbyvUwXtNOta9
is2/w3Mp7TSpZF/fAgMBAAE=
-----END PUBLIC KEY-----`



const serverPrivateKey = ``


export default {
    CLIENT_PUBLIC_KEY: clientPublicKey,
    SERVER_PRIVATE_KEY: serverPrivateKey,
}
